import React, {useCallback, useEffect, useState} from 'react';
import Chart from "react-apexcharts";

import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Theme,
    Typography
} from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';
import {AppBar, ButtonResponsive, ListViewMode, LoadingProgress, MostrarError} from "../../components";
import {FilterList} from "@mui/icons-material";
import Strings from '../../assets/strings'
import {getIngresoVsEgreso} from "../../services";
import {SelectAgente, SelectCartera, SelectRuta} from "../../components/selects";
import {formatDate, formatPeso, moment} from "../../helpers";
import {IKeyValue} from "../../redux/types/Icommon";

const useStyles = makeStyles((theme:Theme) => ({
    root:{
    },
    anulado:{
        background: "#fff1f1",
        "& td, th":{
            color:theme.palette.error.light,
        }
    },
    topTotal:{
        background: theme.palette.grey[200],
        width: 250,
        padding: "3px 8px",
        marginBottom: 7,
        float: "right"
    },
    titleBar:{
        background: theme.palette.grey[200],
        borderBottom: "2px solid "+theme.palette.primary.main,
        marginBottom:theme.spacing(1),
        padding:theme.spacing(1),
    }
}));

interface IData {
    ingresos?: {
        documentoId?: number,
        fecha?: string,
        tipo?: string,
        concepto?: string,
        monto?: number,
        fechaAnulacion?: string
    }[],
    egresos?: {
        documentoId?: 0,
        fecha?: "2024-02-28T17:30:47.114Z",
        tipo?: "string",
        concepto?: "string",
        monto?: 0,
        fechaAnulacion?: "2024-02-28T17:30:47.114Z"
    }[],
    tipos?:  IKeyValue[]
}
const initialState:{fechaDesde:string,fechaHasta:string,agenteId?:number, rutaId?:number, carteraId?:number }={
    fechaDesde: moment(new Date()).format("YYYY-MM-DD"),
    fechaHasta: moment(new Date()).format("YYYY-MM-DD"),
    agenteId: undefined,
    rutaId: undefined,
    carteraId: undefined,
}

export const colorsChart = [
    '#108FFB',
    '#00E396',
    '#FF4560',
    '#FEB019',
    '#775DD0',
    '#8bc34a',
    '#26a69a',
    '#D10CE8',
    '#e91e63',
    '#9c27b0',
    '#673ab7',
    '#3f51b5',
    '#b388ff',
    '#8c9eff',
    '#82b1ff',
    '#03a9f4',
    '#00bcd4',
    '#009688',
    '#caf505',
    '#8bc34a',
    '#cddc39',
    '#ffc107',
    '#ff9800',
    '#ff5722',
    '#795548',
    '#607d8b'
]
export default function Transacciones() {
    const classes = useStyles();
    const [openFilter, setOpenFilter] = useState(false)
    const [filter, setFilter] = useState(initialState);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();

    const [state, setState] = useState<IData>({});


   let fetchData =  useCallback((params: typeof initialState) => {
        setLoading(true)
        getIngresoVsEgreso(params).then(res=>{
            setState(res.data)
        })
            .catch(()=>{})
            .finally(()=>setLoading(false))

    }, [setState, setLoading]);

    useEffect(() => {
        fetchData(initialState)
    }, [fetchData]);

    const handleFilter = (e:React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        setFilter({...filter,[name]:value});
    };

    const searchFilter = () => {
        fetchData(filter)
        setOpenFilter(false);
    };
    const resetFilter = () => {
        setFilter(initialState);
        fetchData(initialState)
        setOpenFilter(false);
    };

    let seriesTypes = [{
        data: state.tipos?.map(item=> +(item.value ?? 0)) ?? []
    }]
    let optionsTypes:ApexCharts.ApexOptions = {
        // title: {
        //     text: 'Total por tipo',
        //     floating: true,
        //     margin:10,
        //     style: {
        //         color: '#444'
        //     }
        // },
        chart: {
            height: 350,
            toolbar: {
                show: true,
                offsetX: 0,
                offsetY: 0,
                tools: {
                    download: false,
                    selection: true,
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: false ,
                },
            },
        },
        colors: colorsChart,

        plotOptions: {
            bar: {
                distributed: true, // this line is mandatory
                horizontal: false,
                //  columnWidth: '65%',
                // endingShape: 'flat'
                // borderRadius: 4,
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }

        },
        // grid: {
        //     borderColor: '#ccc',
        //     strokeDashArray: 7,
        //     xaxis: {
        //         lines: {
        //             show: true
        //         }
        //     }
        // },

        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return formatPeso(val);
            },
            offsetY: -20,
            style: {
                fontSize: '12px',
                colors: colorsChart,
            }
        },

        stroke: {
            show: true,
            width: 1,
            colors: ['transparent']
        },
        xaxis: {
            categories: state.tipos?.map(item=> item.key ) ?? [],
            labels: {
                style: {
                    colors: colorsChart,
                    fontSize: '12px'
                }
            }
        },
        yaxis: {
            labels: {
                formatter: (value) => value.toFixed(),
            }
        },
        fill: {
            opacity: 1
        },
        tooltip: {
            enabled: false,
            shared: true,
            intersect:false,
            followCursor:true,
            y: {
                formatter: (value) => formatPeso(value),
            }
        }

    };

    return (
      <>
          <Dialog open={openFilter} onClose={()=>setOpenFilter(false)} fullWidth maxWidth={"xs"}>
              <DialogContent>
                  <Grid container spacing={3}>
                      <Grid item xs={6} >
                          <TextField
                              label={Strings.fechaDesde}
                              type="date"
                              name="fechaDesde"
                              value={filter.fechaDesde}
                              onChange={handleFilter}
                              fullWidth
                              InputLabelProps={{
                                  shrink: true,
                              }}
                          />
                      </Grid>
                      <Grid item xs={6} >
                          <TextField
                              label={Strings.fechaHasta}
                              type="date"
                              name="fechaHasta"
                              value={filter.fechaHasta}
                              onChange={handleFilter}
                              fullWidth
                              InputLabelProps={{
                                  shrink: true,
                              }}
                          />
                      </Grid>


                      <Grid item xs={12}>
                          <SelectAgente value={filter.agenteId} name={"agenteId"} onChange={handleFilter} />
                      </Grid>

                      <Grid item xs={12}>
                          <SelectCartera value={filter.carteraId} name={"carteraId"} onChange={handleFilter} />
                      </Grid>

                      <Grid item xs={12}>
                          <SelectRuta value={filter.rutaId} name={"rutaId"} onChange={handleFilter} />
                      </Grid>
                  </Grid>
                  <br/>
              </DialogContent>
              <DialogActions>
                  <Button onClick={resetFilter} color="warning" variant={"text"}>{Strings.cancelar}</Button>
                  <Button color="primary" onClick={searchFilter} variant={"outlined"}>{Strings.filtrar}</Button>
              </DialogActions>
          </Dialog>

          <AppBar title={Strings.transacciones}/>
          <section className={"contentInner "+classes.root}>
              {loading && <LoadingProgress vh/>}
              {error && <MostrarError errors={error}/>}
              <ListViewMode noView>
                  <ButtonResponsive icon={<FilterList/>} text={Strings.filtrar} onClick={() => setOpenFilter(!openFilter)}/>
              </ListViewMode>
              <br/>
              <Grid container spacing={3} pb={3}>
                  <Grid item xs={12} md={6} lg={4}>
                      <TableContainer sx={{maxHeight: 302}}>
                          <Table size={"small"}>
                              <TableHead>
                                  <TableRow>
                                      <TableCell>{Strings.tipo}</TableCell>
                                      <TableCell align={"right"}>{Strings.monto} {Strings.total}</TableCell>
                                  </TableRow>
                              </TableHead>
                              <TableBody>
                                  {state.tipos?.map((item, i)=>
                                      <TableRow key={item.key}>
                                          <TableCell sx={{color:colorsChart[i]??"inherit"}}>{item.key}</TableCell>
                                          <TableCell sx={{color:colorsChart[i]??"inherit"}} align={"right"}>{formatPeso(item.value)}</TableCell>
                                      </TableRow>
                                  )}
                              </TableBody>
                          </Table>
                      </TableContainer>
                  </Grid>

                  <Grid item xs={12} md={6} lg={8}>
                      <Paper variant={"outlined"} >
                          <Chart options={optionsTypes} series={seriesTypes} type="bar" height={350} />
                      </Paper>
                  </Grid>
              </Grid>

              <Box className={classes.titleBar}>
                  <Typography color={"secondary"} >{Strings.detalles.toUpperCase()}</Typography>
              </Box>
              <Grid container spacing={3} pb={3}>
                  <Grid item xs={12} lg={6}>
                      <Box className={classes.topTotal} display={"flex"} justifyContent={"right"}>
                          <Typography variant={"body2"} color={"secondary"} pr={2}>{Strings.ingresos.toUpperCase()}:</Typography>
                          <Typography variant={"body2"} color={"secondary"}>{formatPeso(state.ingresos?.filter(e=>!e.fechaAnulacion)?.reduce((a,b)=> a + (b.monto ?? 0), 0))}</Typography>
                      </Box>
                      <TableContainer sx={{maxHeight: 302}}>
                          <Table size={"small"}>
                              <TableHead>


                                  <TableRow>
                                      <TableCell>{Strings.fecha}</TableCell>
                                      <TableCell>{Strings.tipo}</TableCell>
                                      <TableCell>{Strings.concepto}</TableCell>
                                      <TableCell align={"right"}>{Strings.monto}</TableCell>
                                      <TableCell>{Strings.fecha} {Strings.anulacion}</TableCell>
                                  </TableRow>
                              </TableHead>
                              <TableBody>
                                  {state.ingresos?.map(item=>
                                      <TableRow key={item.documentoId} className={item.fechaAnulacion? classes.anulado:undefined}>
                                          <TableCell>{formatDate(item.fecha)}</TableCell>
                                          <TableCell>{item.tipo}</TableCell>
                                          <TableCell>{item.concepto}</TableCell>
                                          <TableCell align={"right"}>{formatPeso(item.monto)}</TableCell>
                                          <TableCell>{formatDate(item.fechaAnulacion)}</TableCell>
                                      </TableRow>
                                  )}
                              </TableBody>
                          </Table>
                      </TableContainer>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                      <Box className={classes.topTotal} display={"flex"} justifyContent={"right"}>
                          <Typography variant={"body2"} color={"secondary"} pr={2}>{Strings.egresos.toUpperCase()}:</Typography>
                          <Typography variant={"body2"} color={"secondary"}>{formatPeso(state.egresos?.filter(e=>!e.fechaAnulacion)?.reduce((a, b)=> a + (b.monto ?? 0), 0))}</Typography>
                      </Box>
                      <TableContainer sx={{maxHeight: 302}}>
                          <Table size={"small"}>
                              <TableHead>
                                  <TableRow>
                                      <TableCell>{Strings.fecha}</TableCell>
                                      <TableCell>{Strings.tipo}</TableCell>
                                      <TableCell>{Strings.concepto}</TableCell>
                                      <TableCell align={"right"}>{Strings.monto}</TableCell>
                                      <TableCell>{Strings.fecha} {Strings.anulacion}</TableCell>
                                  </TableRow>
                              </TableHead>
                              <TableBody>
                                  {state.egresos?.map(item=>
                                      <TableRow key={item.documentoId} className={item.fechaAnulacion? classes.anulado:undefined}>
                                          <TableCell>{formatDate(item.fecha)}</TableCell>
                                          <TableCell>{item.tipo}</TableCell>
                                          <TableCell>{item.concepto}</TableCell>
                                          <TableCell align={"right"}>{formatPeso(item.monto)}</TableCell>
                                          <TableCell>{formatDate(item.fechaAnulacion)}</TableCell>
                                      </TableRow>
                                  )}
                              </TableBody>
                          </Table>
                      </TableContainer>
                  </Grid>
              </Grid>
          </section>
      </>
    );
}
